import React from "react";
import { Link } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
//import { LazyLoadImage } from 'react-lazy-load-image-component';

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";

// import Swiper core and required modules
import { Autoplay, Pagination } from "swiper";

//SwiperCore.use([EffectCoverflow,Pagination]);

// const dataBlog = [
//   { icon: "flaticon-raw-food", title: "Health" },
//   { icon: "flaticon-responsibility", title: "Care" },
//   { icon: "flaticon-vr-glasses", title: "Technology" },
//   { icon: "flaticon-open-book", title: "Education" },
//   { icon: "flaticon-video", title: "Videos" },
//   { icon: "flaticon-like-1", title: "Fashion" },
//   { icon: "flaticon-transformation", title: "Design" },
//   { icon: "flaticon-doctor-bag", title: "Medical" },
// ];

const dataBlog = [
  {
    icon: "flaticon-responsibility",
    title: "Energy",
    content: "Driving innovation with clean and sustainable energy solutions",
  },
  {
    icon: "flaticon-open-book",
    title: "Education",
    content: "Inspiring growth and learning with innovative approaches",
  },
  {
    title: "Technology",
    icon: "flaticon-vr-glasses",
    content: "Empowering progress with advanced technological solutions",
  },
  {
    icon: "flaticon-doctor-bag",
    title: "Health",
    content: "Enhancing well-being with innovative health and care solutions",
  },
];

const CategoriesSlider = () => {
  //const navigationPrevRef = React.useRef(null)
  //const navigationNextRef = React.useRef(null)
  const paginationRef = React.useRef(null);
  return (
    <>
      <Swiper
        className="categories-swiper"
        speed={1500}
        slidesPerView={4}
        spaceBetween={30}
        loop={true}
        centeredSlides={true}
        centerInsufficientSlides={true}
        autoplay={{
          delay: 3000,
        }}
        // modules={[Autoplay, Pagination]}
        //   modules={Pagination]}
        modules={[Autoplay]}
        breakpoints={{
          //   1191: { slidesPerView: 6 },
          1191: { slidesPerView: 4 },
          992: { slidesPerView: 4 },
          768: { slidesPerView: 3 },
          575: { slidesPerView: 3 },
          320: { slidesPerView: 2 },
        }}
      >
        {dataBlog.map((d, i) => (
          <SwiperSlide key={i}>
            <div
              className="icon-bx-wraper text-center style-1 m-b30 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <div className="icon-lg m-sm-b20 m-b30">
                <Link to={"/project"} className="icon-cell">
                  <i className={d.icon}></i>
                </Link>
              </div>
              <div className="icon-content">
                <h6 className="dz-tilte m-b5 text-capitalize">
                  <Link to={"/project"}>{d.title}</Link>
                </h6>
              </div>
            </div>
          </SwiperSlide>
        ))}
        <div
          className="swiper-pagination style-1 text-center"
          ref={paginationRef}
        ></div>
      </Swiper>
    </>
  );
};

export default CategoriesSlider;
